import gsap from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)
import Base from '../../../src/js/classes/Base'
import Flickity from 'flickity'
import imagesLoaded from 'imagesloaded'

export default class Product extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				colorButton: '.s-Product__details__top__colors button',
				colors: '.s-Product__details__top__colors__info',
				color: '.s-Product__details__top__colors__info__color',
				productImages: '.product-image',
				gallery: '.s-Product__images__gallery-container',
				index: '.s-Product__images__index',
			},
			options: {},
			classes: {
				active: 'active',
			},
			state: {
				isColorsOpen: false,
			},
		})
	}

	init() {
		this.elements.color = gsap.utils.toArray(this.elements.color)
		this.elements.productImages = gsap.utils.toArray(this.elements.productImages)
		this.initMatchMedia()
		this.addEvents()
	}

	addEvents() {
		if (this.elements.colorButton) {
			this.elements.colorButton.addEventListener('click', this.onClickColorButtons.bind(this))
			this.elements.color.forEach((color) => {
				color.addEventListener('click', this.onClickColor.bind(this))
			})
		}
		imagesLoaded(this.elements.gallery, () => {
			this.createSlider()
		})
	}

	createSlider() {
		// create
		this.mm = gsap.matchMedia()

		// add a media query. When it matches, the associated function will run
		this.mm.add('(max-width: 1025px)', () => {
			// console.log(this.elements.gallery.clientHeight)
			this.flkty = new Flickity(this.elements.gallery, {
				wrapAround: false,
				pageDots: true,
				initialIndex: 0,
				prevNextButtons: false,
				resize: true,
				draggable: true,
				autoPlay: false,
				pauseAutoPlayOnHover: false,
				cellAlign: 'left',
				contain: true,
				adaptiveHeight: true,
			})

			return () => {
				if (this.flkty) {
					this.flkty.destroy()
				}
				// optional
				// custom cleanup code here (runs when it STOPS matching)
			}
		})
	}

	onClickColorButtons(e) {
		if (this.state.isColorsOpen) {
			this.closeColors()
		} else {
			this.openColors()
		}
	}

	initMatchMedia() {
		this.colorMM = gsap.matchMedia()
		this.colorMM.add('(min-width: 1025px)', (context) => {
			this.handleColorClick = (e) => {
				const id = e.target.dataset.sColorId

				const firstImage = this.elements.productImages.find((image) => image.dataset.sColorId === id)
				if (firstImage) {
					// firstImage.scrollIntoView({ behavior: 'smooth', block: 'start' })
					const paddingOffset = parseInt(getComputedStyle(document.querySelector('.s-Product__images')).paddingTop, 10) || 0
					gsap.to(window, { scrollTo: { y: firstImage.offsetTop + paddingOffset, offsetY: 0 }, duration: 1 })
				}
			}
		})

		this.colorMM.add('(max-width: 1024px)', (context) => {
			this.handleColorClick = (e) => {
				const id = e.target.dataset.sColorId
				this.elements.gallery.scrollIntoView({ behavior: 'smooth' })
				const index = this.flkty.cells.find((cell) => cell.element.dataset.sColorId === id).element.dataset.sIndex
				this.flkty.select(index)
			}
		})
	}

	onClickColor(e) {
		if (typeof this.handleColorClick === 'function') {
			this.handleColorClick(e)
		}
	}

	closeColors() {
		this.state.isColorsOpen = false
		this.elements.colorButton.classList.remove(this.classes.active)
		gsap.to(this.elements.colors, {
			height: 0,
			duration: 0.3,
			ease: 'power1.in',
		})
	}

	openColors() {
		this.state.isColorsOpen = true
		this.elements.colorButton.classList.add(this.classes.active)
		gsap.to(this.elements.colors, {
			height: 'auto',
			duration: 0.5,
			ease: 'power2.out',
		})
	}

	removeEvents() {
		if (this.elements.colorButton) {
			this.elements.colorButton.removeEventListener('click', this.onClickColorButtons.bind(this))
			this.elements.color.forEach((color) => {
				color.removeEventListener('click', this.onClickColor.bind(this))
			})
		}
		this.mm.revert()
		if (this.colorMM) {
			this.colorMM.revert()
		}
	}

	resize() {}

	update() {}

	unmount() {
		this.removeEvents()
	}
}
